import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "onedesk-input" };
const _hoisted_2 = { key: 1 };
const _hoisted_3 = { class: "one-desk-input-max-length" };
import InlineMessage from "primevue/inlinemessage";
import Textarea from "primevue/textarea";
import { computed, useSlots, watch } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'OneDeskTextArea',
    props: /*#__PURE__*/ _mergeModels({
        lineraLabel: { type: Boolean, default: true },
        placeholder: { default: "" },
        disabled: { type: Boolean, default: false },
        maxLength: {},
        rules: {},
        rows: {},
        cols: {}
    }, {
        "modelValue": { default: "" },
        "modelModifiers": {},
    }),
    emits: /*#__PURE__*/ _mergeModels(["update:valid"], ["update:modelValue"]),
    setup(__props, { emit: __emit }) {
        const modelValue = _useModel(__props, "modelValue");
        const props = __props;
        const errorMessages = computed(() => {
            if (!props.rules)
                return [];
            return props.rules?.map((rule) => rule(modelValue.value)).filter((result) => result !== true);
        });
        const emit = __emit;
        watch(() => errorMessages.value, (value) => {
            emit("update:valid", value.length === 0);
        });
        const slots = useSlots();
        const hasSlot = (name) => {
            return !!slots[name];
        };
        const labelClassName = computed(() => "onedesk-input-label " + (props.lineraLabel ? "onedesk-inoput-label-linear" : ""));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (hasSlot('label'))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(labelClassName.value)
                    }, [
                        _renderSlot(_ctx.$slots, "label")
                    ], 2))
                    : _createCommentVNode("", true),
                _createVNode(_unref(Textarea), {
                    type: "text",
                    disabled: _ctx.disabled,
                    modelValue: modelValue.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((modelValue).value = $event)),
                    class: "one-desk-input",
                    placeholder: _ctx.placeholder,
                    invalid: errorMessages.value.length > 0,
                    rows: props.rows,
                    cols: props.cols
                }, null, 8, ["disabled", "modelValue", "placeholder", "invalid", "rows", "cols"]),
                (props.maxLength)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("span", _hoisted_3, _toDisplayString(modelValue.value.length) + "/" + _toDisplayString(props.maxLength), 1)
                    ]))
                    : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errorMessages.value, (error, index) => {
                    return (_openBlock(), _createBlock(_unref(InlineMessage), {
                        key: index,
                        severity: "error",
                        class: "my-2"
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(error), 1)
                        ]),
                        _: 2
                    }, 1024));
                }), 128))
            ]));
        };
    }
});
